
const scrollToTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export default scrollToTop;
